// src/utils/passive-events-patch.js

const originalAddEventListener = EventTarget.prototype.addEventListener;

const passiveEvents = [
  'touchstart',
  'wheel',
  'mousewheel',
  'touchmove',
  'scroll',
];

const forcePassiveTrueEvents = ['touchstart','touchmove']; // para vue-cal
const forcePassiveFalseEvents = []; // para Vuetify

EventTarget.prototype.addEventListener = function (type, listener, options) {
  const isPassiveEvent = passiveEvents.includes(type);

  if (!isPassiveEvent) {
    return originalAddEventListener.call(this, type, listener, options);
  }

  let finalOptions = options;

  // Se for um objeto (ex: { passive: true, capture: false })
  if (typeof options === 'object' && options !== null) {
    finalOptions = { ...options };

    if (forcePassiveTrueEvents.includes(type)) {
      finalOptions.passive = true;
    } else if (forcePassiveFalseEvents.includes(type)) {
      finalOptions.passive = false;
    }

  // Se for booleano (capture)
  } else if (typeof options === 'boolean' || options === undefined) {
    if (forcePassiveTrueEvents.includes(type)) {
      finalOptions = { passive: true, capture: !!options };
    } else if (forcePassiveFalseEvents.includes(type)) {
      finalOptions = { passive: false, capture: !!options };
    }
  }

  return originalAddEventListener.call(this, type, listener, finalOptions);
};
